import { AnyAction } from '@reduxjs/toolkit';
import {
  AssignUserRoutine,
  CreateQuestionRoutine,
  DeleteQuestionRoutine,
  FetchSurveyRoutine,
  UnassignUserRoutine,
  UpdateSurveyRoutine
} from '../redux-routines';
import { IQuestion, ISurveyState, ISurveyUser } from '../interfaces';

export type { ISurveyState };
const initialState: ISurveyState = {
  isFetching: false,
  data: null,
  error: null
};
export const surveyReducer = (
  state: ISurveyState = initialState,
  action: AnyAction
): ISurveyState => {
  switch (action.type) {
    // Fetch survey
    case FetchSurveyRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchSurveyRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchSurveyRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    // Update survey
    case UpdateSurveyRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case UpdateSurveyRoutine.SUCCESS: {
      const data = action.payload as ISurveyState['data'];
      return {
        ...state,
        data,
        isFetching: false,
        error: null
      };
    }
    case UpdateSurveyRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    // Create question
    case CreateQuestionRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case CreateQuestionRoutine.SUCCESS:
      if (!state.data) {
        return state;
      }
      return {
        ...state,
        data: {
          ...state.data,
          questions: [
            ...state.data.questions,
            { ...(action.payload as Omit<IQuestion, 'questionAnswers'>), questionAnswers: [] }
          ]
        },
        isFetching: false,
        error: null
      };
    case CreateQuestionRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    // Delete question
    case DeleteQuestionRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case DeleteQuestionRoutine.SUCCESS:
      if (!state.data) {
        return state;
      }
      const questions = state.data.questions.filter((question: IQuestion) => {
        return question.questionId !== action.payload;
      });
      return {
        ...state,
        data: {
          ...state.data,
          questions
        },
        isFetching: false,
        error: null
      };
    case DeleteQuestionRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    // Assign user to the survey
    case AssignUserRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case AssignUserRoutine.SUCCESS:
      if (!state.data) {
        return state;
      }
      return {
        ...state,
        data: {
          ...state.data,
          users: [
            ...state.data.users,
            action.payload as ISurveyUser
          ]
        },
        isFetching: false,
        error: null
      };
    case AssignUserRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    // Unassign user to the survey
    case UnassignUserRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case UnassignUserRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null
      };
    case UnassignUserRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};